import { useEffect, useState } from 'react';

// Callers re-mount by keying on it: https://www.joshwcomeau.com/react/the-perils-of-rehydration/
export function useClient() {
	const [clientOnly, setClientOnly] = useState(false);
	useEffect(() => {
		setClientOnly(true);
	}, []);
	return clientOnly;
}
